import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        console.log("EnquiriesFilterQuickLookController connected");
    }

    async showQuickLook(event) {
        event.preventDefault();

        let url = '/schools/enquiries/quick-look/filter'

        const response = await this.performFetch(url, "GET");

        if (response.ok) {
            const quickViewElement = document.querySelector("#enquiries-filter-quick-look");
            quickViewElement.classList.remove("u-hidden");

            const responseBody = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseBody, "text/html");
            const template = xmlDoc.querySelector("template");
            const turboFrameElement = quickViewElement;

            if (turboFrameElement && template) {
                turboFrameElement.innerHTML = "";
                turboFrameElement.appendChild(template.content.cloneNode(true));
            }
        }
    }

    async performFetch(url, method, body = null) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        const headers = {
            "X-CSRF-Token": csrfToken,
            "Accept": "text/vnd.turbo-stream.html"
        };

        const options = {
            method: method,
            headers: headers
        };

        if (body) {
            options.body = body;
        }

        try {
            return await fetch(url, options);
        } catch (error) {
            console.error("Error performing fetch: ", error);
            return { error: "Network error, please check your connection and try again." };
        }
    }

    closeQuickLook(event) {
        event.preventDefault();

        const quickViewElement = document.querySelector("#enquiries-filter-quick-look");
        quickViewElement.classList.add("u-hidden");
    }

    resetFilters(event) {
        this.refreshEnquiriesList(null);
        this.closeQuickLook(event);
    }

    filterInstructorSelected(event) {
        let selectedInstructor = event.detail.id

        // Refresh the enquiries list with the new instructor filter
        this.refreshEnquiriesList(selectedInstructor);

    }

    refreshEnquiriesList(instructorId) {
        const frame = document.getElementById('school_enquiry_list');

        if (frame) {
            // Get current URL and update the instructor_id parameter
            const currentSrc = frame.src;
            const url = new URL(currentSrc);
            url.searchParams.set('instructor_id', instructorId);

            // Update the frame source to trigger reload
            frame.src = url.toString();
        }
    }
}